import { render, staticRenderFns } from "./AllocationStatus.vue?vue&type=template&id=999c2ef2&scoped=true&"
import script from "./AllocationStatus.vue?vue&type=script&lang=ts&"
export * from "./AllocationStatus.vue?vue&type=script&lang=ts&"
import style0 from "./AllocationStatus.vue?vue&type=style&index=0&id=999c2ef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999c2ef2",
  null
  
)

export default component.exports